import BasePeripheral from "./BasePeripheral";
import { base64ToFile } from "utils/file";
import { PhotoResponse, SupportHandlers } from "./type";

class Camera extends BasePeripheral {
  protected name = SupportHandlers.requestPhotoDataAtNeptune;

  public onResponse(callback: (data: PhotoResponse) => void) {
    this.addListener(({ data, identify_info }) => {
      callback({ data: this.transform(data), identify_info });
    });
  }

  public request(identify_info: string): void {
    this.callHandler(identify_info);
  }

  protected transform(data: any) {
    const mimeType = "data:image/jpeg;base64";
    const fileName = `${new Date().getTime()}.jpg`;

    return data
      ? base64ToFile(
          !data.includes(mimeType) ? `${mimeType},${data}` : data,
          fileName
        )
      : null;
  }

  public isCameraConnected() {
    return this.hasMessageHandlers(SupportHandlers.requestPhotoDataAtNeptune);
  }
}

export default Camera;
